/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
  aws_project_region: "us-west-2",
  aws_cognito_identity_pool_id:
    "us-west-2:8a87cff1-9f93-4b0f-95a0-918ebaa6a40d",
  aws_cognito_region: "us-west-2",
  aws_user_pools_id: "us-west-2_RPKs1d8k5",
  aws_user_pools_web_client_id: "5dmj84co3olmkv78o35koad2c3",
  oauth: {
    domain: "nunchi1db01412-1db01412-prod.auth.us-west-2.amazoncognito.com",
    scope: [
      "phone",
      "email",
      "openid",
      "profile",
      "aws.cognito.signin.user.admin",
    ],
    redirectSignIn:
      "http://localhost:8100/dashboard,https://dev.nunchi.app/dashboard,https://nunchi.app/dashboard",
    redirectSignOut:
      "http://localhost:8100/auth,https://dev.nunchi.app/auth,https://nunchi.app/auth",
    responseType: "code",
  },
  federationTarget: "COGNITO_USER_POOLS",
  aws_cognito_username_attributes: ["EMAIL"],
  aws_cognito_social_providers: ["GOOGLE"],
  aws_cognito_signup_attributes: ["EMAIL"],
  aws_cognito_mfa_configuration: "OFF",
  aws_cognito_mfa_types: ["SMS"],
  aws_cognito_password_protection_settings: {
    passwordPolicyMinLength: 8,
    passwordPolicyCharacters: [],
  },
  aws_cognito_verification_mechanisms: ["EMAIL"],
};

export default awsmobile;
